import { Directive, ElementRef, HostListener, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogSize } from '../constants';
import { ImageRotationService } from '../../ui-kit/carousel-gallery/image-rotation.service';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from '../decorators/auto-unsubscribe.decorator';

@Directive({
  selector: '[zoomImage]',
  standalone: false,
})
@AutoUnsubscribe
export class ZoomImagePopupDirective {
  @Input() carouselParams: {
    imageIndex?: number;
    imageList?: string[];
  };

  @Output() updateImage: EventEmitter<{ url: string; index: number }> = new EventEmitter(null);

  @HostListener('click') async onClick(): Promise<void> {
    const { imageIndex, imageList } = { ...this.carouselParams };
    const isRotationAllowed = !!this.carouselParams;

    this.subscriptions.push(
      this.imageRotationService.rotation$.subscribe((rotatedURL: { url: string; index: number }) => {
        this.updateImage.emit(rotatedURL);
      }),
    );

    const { CarouselGalleryComponent } = await import('../../ui-kit/carousel-gallery/carousel-gallery.component');

    const dialogRef = this.dialog.open(CarouselGalleryComponent, {
      width: DialogSize.XXL,
      panelClass: 'carousel-gallery-popup',
      data: {
        imageList,
        imageIndex,
        imageSrc: this.elementRef.nativeElement.currentSrc,
        isRotationAllowed,
      },
    });

    this.subscriptions.push(
      dialogRef.componentInstance.closeButtonClicked.subscribe(() => {
        this.imageRotationService.updateRotatedImageURL(null, null);
      }),
    );
  }

  subscriptions: Subscription[] = [];

  constructor(
    private dialog: MatDialog,
    private elementRef: ElementRef,
    private imageRotationService: ImageRotationService,
  ) {}
}
